{% block scop_platform_redirect_details %}
    <sw-page class="scop-platform-redirect-details">
        <template #smart-bar-actions>
            <sw-button size="default"
                       variant="secondary" :routerLink="{name: 'scop.platform.redirect.list'}">
                {{ $t('scopplatformredirecter.detail.cancelButton') }}</sw-button>
            <sw-button-process :isLoading="isLoading"
                               :processSuccess="processSuccess" variant="primary"
                               @update:processSuccess="saveFinish" @click="onClickSave">
                {{ $t('scopplatformredirecter.detail.saveButton') }}</sw-button-process>
        </template>
        <template #content>
            <sw-card-view>
                <sw-card v-if="redirect" :isLoading="isLoading">
                    <sw-text-field :label="$t('scopplatformredirecter.detail.sourceUrlLabel')" v-model:value="redirect.sourceURL"
                              validation="required"></sw-text-field>
                    <sw-text-field :label="$t('scopplatformredirecter.detail.targetUrlLabel')" v-model:value="redirect.targetURL"
                              validation="required"></sw-text-field>
                    <sw-select-number-field :label="$t('scopplatformredirecter.detail.httpCodeLabel')"
                                            v-model:value="redirect.httpCode" validation="required" @update:value="transformHttpCodeValueToNumber">
                        <option value=301>{{ $t('scopplatformredirecter.detail.httpCodeLabelValues.301') }}</option>
                        <option value=302>{{ $t('scopplatformredirecter.detail.httpCodeLabelValues.302') }}</option>
                    </sw-select-number-field>
                    <sw-switch-field :label="$tc('scopplatformredirecter.detail.enabledLabel')"
                                     v-model:value="redirect.enabled" validation="required"></sw-switch-field >
                    <sw-select-number-field :label="$t('scopplatformredirecter.detail.queryParamsHandling')"
                                            v-model:value="redirect.queryParamsHandling" validation="required" @update:value="transformQueryFieldValueToNumber">
                        <option value=0>{{ $t('scopplatformredirecter.detail.queryParamsHandlingValues.consider') }}</option>
                        <option value=1>{{ $t('scopplatformredirecter.detail.queryParamsHandlingValues.ignore') }}</option>
                        <option value=2>{{ $t('scopplatformredirecter.detail.queryParamsHandlingValues.transfer') }}</option>
                    </sw-select-number-field>

                    <sw-entity-single-select v-model:value="redirect.salesChannelId" entity="sales_channel" :resetOption="$t('scopplatformredirecter.detail.salesChannel.all')" :label="$t('scopplatformredirecter.detail.salesChannel.select')"></sw-entity-single-select>
                </sw-card>
            </sw-card-view>
        </template>
    </sw-page>
{% endblock %}
